export const blockMap = function ($block) {
  $(".block-map__link").click(function (e) {
    e.preventDefault();
    $(".block-map__address").removeClass("active");
    $(".block-map__link").removeClass("active");
    $(this).addClass("active");
    let id = $(this).data("id");
    $(".block-map__address[data-id='" + $(this).data("id") + "']").addClass(
      "active"
    );
  });
};
